import React, { useState, useEffect } from "react";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import styles from "./DateRangeFilter.module.css";

interface DateRangeFilterProps {
  onClose: () => void;
  onApply: (dates: [Dayjs | null, Dayjs | null]) => void;
  initialDates: [Dayjs | null, Dayjs | null];
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  onClose,
  onApply,
  initialDates,
}) => {
  const [startDate, setStartDate] = useState<Dayjs | null>(initialDates[0]);
  const [endDate, setEndDate] = useState<Dayjs | null>(initialDates[1]);
  const [selectedPreset, setSelectedPreset] = useState<string | null>(null);

  useEffect(() => {
    setStartDate(initialDates[0]);
    setEndDate(initialDates[1]);
  }, [initialDates]);

  const handlePresetChange = (preset: string) => {
    setSelectedPreset(preset);
    let start = dayjs();
    const end = dayjs();

    switch (preset) {
      case "Last 7 Days":
        start = end.subtract(7, "day");
        break;
      case "Last 30 Days":
        start = end.subtract(30, "day");
        break;
      case "Last 3 Month":
        start = end.subtract(3, "month");
        break;
      case "Last 6 Month":
        start = end.subtract(6, "month");
        break;
      case "Last 1 Year":
        start = end.subtract(1, "year");
        break;
      case "Last 2 Year":
        start = end.subtract(2, "year");
        break;
      default:
        start = dayjs();
    }
    setStartDate(start);
    setEndDate(end);
  };

  const handleApply = () => {
    onApply([startDate, endDate]);
    onClose();
  };

  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedPreset(null);
    onApply([null, null]);
    onClose();
  };

  const presets = [
    "Last 7 Days",
    "Last 30 Days",
    "Last 3 Month",
    "Last 6 Month",
   
  ];

  const handleDateInputChange = (
    setter: (date: Dayjs | null) => void,
    value: string
  ) => {
    setter(value ? dayjs(value) : null);
  };

  return (
    <div className={styles.filterPopoverContent}>
      <div className={styles.datePickerWrapper}>
        <div className={styles.datePickerContainer}>
          <label className={styles.dateLabel}>From Date:</label>
          <input
            type="date"
            value={startDate ? startDate.format("YYYY-MM-DD") : ""}
            onChange={(e) =>
              handleDateInputChange(setStartDate, e.target.value)
            }
            className={styles.dateInput}
          />
        </div>
        <div className={styles.datePickerContainer}>
          <label className={styles.dateLabel}>To Date:</label>
          <input
            type="date"
            value={endDate ? endDate.format("YYYY-MM-DD") : ""}
            onChange={(e) => handleDateInputChange(setEndDate, e.target.value)}
            className={styles.dateInput}
          />
        </div>
      </div>
      <div className={styles.presetContainer}>
        <div className={styles.presetGrid}>
          {presets.map((preset) => (
            <div key={preset}>
              <label className={styles.radioLabel}>
                <input
                  type="checkbox"
                  name="date-preset"
                  checked={selectedPreset === preset}
                  onChange={() => handlePresetChange(preset)}
                  className={styles.radioInput}
                />
                {preset}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.footerButtons}>
        <button className={styles.clearButton} onClick={handleClear}>
          Clear All
        </button>
        <button className={styles.applyButton} onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default DateRangeFilter;
